export const DEFAULTS_BASE_URL = `https://api-contact.syon.co.jp/db_api`;
export const API_KEY = `ssfSBlq4tb7IoLFf7x0Zo51zLssNdnrk4e9X1Qtk`;
// date
export const timeCurrentIso8601 = () =>
  new Intl.DateTimeFormat("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    fractionalSecondDigits: undefined,
  }).format(new Date());
export const tomorrowYmd = () => {
  const dt = new Date();
  return new Intl.DateTimeFormat("ja-JP", {
    dateStyle: "short",
  })
    .format(dt.setDate(dt.getDate() + 1))
    .replace(/\//g, "-");
};
export const todayYmd = () => {
  return new Intl.DateTimeFormat("ja-JP", {
    dateStyle: "short",
  })
    .format(new Date())
    .replace(/\//g, "-");
};
